import varAxios from "../../Comman/axios";
import decode from 'jwt-decode';
import { userLoginUrl } from "../../Comman/apiEndPoints"

export const FETCH_LOGIN_REQUEST = "(login) FETCH LOGIN REQUEST";
export const FETCH_LOGIN_SUCCESS = "(login) FETCH LOGIN SUCCESS";
export const FETCH_LOGIN_ERROR = "(login) FETCH LOGIN ERROR";
export const LOGOUT_USER_REQUEST = "(logout) LOGOUT USER REQUEST"

export const LOGIN_VIEW_REQUEST = "(login) LOGIN VIEW REQUEST"


export function fetchLoginRequest({ userName, isLoading, password }) {
    return {
        type: FETCH_LOGIN_REQUEST,
        userName,
        isLoading,
        password
    }
}
export function fetchLoginViewRequest() {
    let statusCode='';
    return {
        type: LOGIN_VIEW_REQUEST,
        statusCode
    }
}

export function fetchLoginSuccess({ userName, isLoading, password, Message, loginStatus, authTokenId, userId }) {
    return {
        type: FETCH_LOGIN_SUCCESS,
        userName,
        isLoading,
        password,
        Message,
        loginStatus,
        authTokenId,
        userId
    }
}
export function fetchLoginError({ statusCode, errorCode, errorMessage }) {
    return {
        type: FETCH_LOGIN_ERROR,
        statusCode,
        errorCode,
        errorMessage
    }
}

export function loginUser(userName, password,dispatch) {
    let data = {
        userName: userName,
        password: password,
        //DeviceKey:deviceKey
    }

    return (dispatch) => {
        dispatch(fetchLoginRequest({ userName: userName, isLoading: true, password: password }));
        return varAxios.post(userLoginUrl, data,
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
            .then((response) => {
                console.log(response)
                dispatch(
                    fetchLoginSuccess({
                        userName: userName, isLoading: false, password: password,
                        Message: response.data.Message, 
                        loginStatus: response.data.statusCode,
                        authTokenId: response.data.authToken, 
                        userId: response.data.User.UserId
                    }));
                setToken(response.data) // Setting the token in localStorage
                return Promise.resolve(response.data);

                // var promise1 = Promise.resolve(response.data);

                // promise1.then(function (value) {
                //     return <Redirect to="/User/ViewSettings" />;
                //     // expected output: 123
                // });
            })
            .catch((error) => {
                
                dispatch(
                    fetchLoginError({
                        statusCode: error.response.data.statusCode,
                        errorCode: error.response.data.errorCode, 
                        errorMessage: error.response.data.errorMessage,
                    }));
            })

    }
}



export function logOutUserRequest({ userName, isLoading, password, Message, loginStatus, authTokenId, userId }) {
    return {
        type: LOGOUT_USER_REQUEST,
        userName,
        isLoading,
        password,
        Message,
        loginStatus,
        authTokenId,
        userId
    }
}

export function logOutUser() {
    return (dispatch) => {
        dispatch(logOutUserRequest({ userName: "", isLoading: false, password: "", Message: "", loginStatus: 0, authTokenId: "", userId: 0 }));
    }
}

export function loggedIn(authTokenId) {
    // Checks if there is a saved token and it's still valid 
    const token = getToken() // GEtting token from localstorage
    /*if (token !== authTokenId)
        return false;
    else*/
        return !!token && !isTokenExpired(token) // handwaiving here
}

function isTokenExpired(token) {
    try {
        const decoded = decode(token);
        if (decoded.exp < Date.now() / 1000) { // Checking if token is expired. N
            return true;
        }
        else
            return false;
    }
    catch (err) {
        return false;
    }
}

function setToken(data) {
    // Saves user token to localStorage
    localStorage.setItem('userid_token',data.authToken)
    localStorage.setItem('UserID', data.User.UserId)
    localStorage.removeItem('id_admin_token');
    localStorage.removeItem('OrganizationID');
    sessionStorage.removeItem('id_super_admin_token');
    
}

export function getToken() {
    // Retrieves the user token from localStorage
    return localStorage.getItem('userid_token')
    

}
export function getUserID() {
    // Retrieves the user token from localStorage
    return localStorage.getItem('UserID')
}

export function logout() {
    // Clear user token and profile data from localStorage
    localStorage.removeItem('userid_token');
    localStorage.removeItem('UserID');

}

export function getProfile() {
    // Using jwt-decode npm package to decode the token
    return decode(getToken());
}


